import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { DeleteDiagnosticFilterValueHandler } from "./handler";
import { DeleteDiagnosticFilterValueCommand } from "./request";

let deleteFilterValueRequest: BrokerDisposableHandler;

export const bootstrapDeleteDiagnosticFilterValue = (broker: BrokerExtensions) => {
  deleteFilterValueRequest = broker.registerRequest(DeleteDiagnosticFilterValueCommand, DeleteDiagnosticFilterValueHandler);
};

export const teardownDeleteDiagnosticFilterValue = () => {
  deleteFilterValueRequest?.dispose();
};
